import { deleteRequest } from '~/shared/utils';

export async function deleteUserAccount(apiUrl: string, headers?: HeadersInit) {
    const request = await deleteRequest<void, void>(apiUrl, undefined, headers);

    const response = await request();

    return response;
}
